import { createLoaderImp } from '../../../../../components/ozmoit/common/loader-imp';
import { StudentsRiskHistoryDetailsAction } from '../actions';

const {
  useLoader: useStudentsRiskHistoryDetails,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: StudentsRiskHistoryDetailsAction,
});

function StudentsRiskHistoryDetailsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { StudentsRiskHistoryDetailsLoader, useStudentsRiskHistoryDetails };
